import { createRef, useEffect, useState } from 'react';

import ReCAPTCHA from 'react-google-recaptcha';

export const HOC = (Component: React.ComponentType) =>
  function Comp(props: any) {
    const recaptchaRef = createRef<ReCAPTCHA>();
    const [captchaToken, setCapchaToken] = useState<string>('');
    const [captchaFlag, setCaptchaFlag] = useState(process.env.NX_APP_GOOGLE_CAPTCHA_ENABLE);
    useEffect(() => {
      async function captchaExecute() {
        const token = await recaptchaRef?.current?.executeAsync();
        token && setCapchaToken(token ? token : '');
        token && setCaptchaFlag('false');
      }
      process.env.NX_APP_GOOGLE_CAPTCHA_ENABLE === 'true' && captchaExecute();
    }, [recaptchaRef]);

    const additionalProp = {
      captcha_token: captchaToken,
      captcha_enabled: captchaFlag,
    };
    return (
      <>
        {process.env.NX_APP_GOOGLE_CAPTCHA_ENABLE === 'true' && (
          // @ts-ignore
          <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey="6LfeeLEcAAAAAJYiWXM0aA6fKIdvJ5NWmcU8q_E4" />
        )}
        <Component additionalProp={additionalProp} {...(props as any)} />
      </>
    );
  };
